import remToPxValue from './remToPxValue';
import spacing from './spacing';
export const optionBorderWidth = 1;
export const optionPadding = spacing.base;
export const selectedOptionBorderWidth = 2;
export const borderWidthDifference = selectedOptionBorderWidth - optionBorderWidth;
export const selectedOptionPadding = remToPxValue(optionPadding) - borderWidthDifference;
export const totalBorderOffset = (optionBorderWidth + remToPxValue(optionPadding)) * 2;
